/** @jsx jsx */

import { jsx } from '@emotion/core';
import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableTh,
} from '@zapier/design-system';

import CollapsibleRow from './CollapsibleRow';

import type { EventType } from '../types';

type Props = {
  events: Array<EventType>;
};

function CollapsibleMonitoringTable({ events }: Props) {
  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableTh>Event</TableTh>
          <TableTh>Date</TableTh>
          <TableTh>Type</TableTh>
          <TableTh>Key</TableTh>
          <TableTh>Task</TableTh>
        </TableRow>
      </TableHead>
      <TableBody>
        {events.map(event => (
          <CollapsibleRow event={event} key={event.id} />
        ))}
      </TableBody>
    </Table>
  );
}

export default CollapsibleMonitoringTable;
